module.exports = __webpack_public_path__ + "themify.a1ecc3b826d01251eddd.woff";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/themify-icons/fonts/themify.woff
// module id = ../../../../../src/assets/scss/icons/themify-icons/fonts/themify.woff
// module chunks = styles